import { styled } from "@mui/material/styles";
import { Box, Stack } from "@mui/material";
import Banner from "./components/Banner";
import BackedBy from "./components/BackedBy";
import Why from "./components/Why";
import Team from "./components/Team";
import Introduction from "./components/Introduction";
import Features from "./components/Features";
import Partners from "./components/Partners";
import Contact from "./components/Contact";

const Containter = styled(Stack)`
  overflow: hidden;
`;

const Home = () => {
  return (
    <Containter>
      <Banner />
      <BackedBy />
      <Introduction />
      <Features />
      <Partners />
      <Contact />
      {/* <Why /> */}
      {/* <Partners /> */}
      {/* <Team /> */}
      {/* <SecurityConcern /> */}
    </Containter>
  );
};

export default Home;
